import React from 'react';
import p from 'translation';
import { App } from 'core/types/app';

import { ReactComponent as LibraryIcon } from './icon/library.svg';
import { ReactComponent as CalendarIcon } from './icon/calendar.svg';
import icon from './icon.svg';

const videos: App = {
  id: 'videos',
  name: p.t('videos.name'),
  icon,
  color: {
    main: '#cc8004',
    light: '#ffaf42',
    dark: '#cc8004',
    contrastText: '#fff',
  },
  app: React.lazy(() => import(/* webpackChunkName: "videos" */ './app')),
  navigation: [
    {
      title: p.t('videos.library.title'),
      path: '/',
      hasAccess: () => true,
      icon: <LibraryIcon />,
      forceActive: () =>
        window.location.pathname.includes('/app/videos/playlist') ||
        window.location.pathname.includes('/app/videos/publisher'),
    },
    {
      title: p.t('videos.calendar.title'),
      path: '/calendar',
      hasAccess: () => true,
      icon: <CalendarIcon />,
    },
  ],
};

export default videos;
